export default __webpack_public_path__ + "static/media/calculator.7655cfe4.svg";